export default __webpack_public_path__ + "static/media/caen6.9e318236.jpg";